import { useEffect, useState } from "react";
import { Loader2, Award, Clock, AlertCircle } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, Avatar } from "@/components/common/ui";

const CERT = { valid: "#12B76A", expiring: "#F79009", expired: "#F04438" };

export default function Staff() {
  const [staff, setStaff] = useState(null);
  useEffect(() => { api.get("/staff").then((r) => setStaff(r.data)).catch(() => setStaff([])); }, []);
  if (!staff) return <div className="flex h-64 items-center justify-center text-muted-foreground"><Loader2 className="animate-spin" /></div>;

  return (
    <div>
      <PageHeader overline="Workforce · Talent" title="Staff"
        description="Workforce profiles with certifications, workload and burnout-risk signals. Sensitive characteristics are never used as predictors." />
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {staff.map((s, i) => (
          <div key={s.id} data-testid={`staff-card-${s.id}`} className="careiq-rise rounded-xl border bg-card p-4 shadow-sm" style={{ animationDelay: `${i * 30}ms` }}>
            <div className="flex items-center gap-3">
              <Avatar name={`${s.first_name} ${s.last_name}`} seed={i + 2} size={44} />
              <div className="min-w-0 flex-1">
                <div className="truncate font-semibold">{s.first_name} {s.last_name}</div>
                <div className="truncate text-xs text-muted-foreground">{s.title}</div>
              </div>
              <span className="rounded-full px-2 py-0.5 text-[10px] font-semibold"
                style={{ color: s.burnout_risk === "High" ? "#F04438" : s.burnout_risk === "Moderate" ? "#F79009" : "#12B76A",
                  backgroundColor: (s.burnout_risk === "High" ? "#F04438" : s.burnout_risk === "Moderate" ? "#F79009" : "#12B76A") + "1a" }}>
                {s.burnout_risk} burnout
              </span>
            </div>
            <div className="mt-3 flex items-center gap-4 text-xs text-muted-foreground">
              <span className="flex items-center gap-1"><Clock size={12} /> {s.hours_week}h/wk</span>
              {s.overtime_hours > 0 && <span className="flex items-center gap-1 text-[#F79009]"><AlertCircle size={12} /> {s.overtime_hours}h OT</span>}
            </div>
            {(s.certifications || []).length > 0 && (
              <div className="mt-3 space-y-1.5 border-t pt-3">
                {s.certifications.map((c, j) => (
                  <div key={j} className="flex items-center justify-between text-xs">
                    <span className="flex items-center gap-1.5"><Award size={12} /> {c.name}</span>
                    <span className="font-medium" style={{ color: CERT[c.status] }}>{c.status} · {c.expires}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
